import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_SOCIAL_USER } from 'reactApp/appHelpers/configHelpers';

export const restoreTrashbinFiles =
    !IS_MOBILE_BROWSER && !IS_PAID_USER && !IS_BIZ_USER && !IS_SOCIAL_USER && getFeature('restore-trashbin-files');
